import { Component } from '@angular/core';
import { MessageNotificationService } from 'message-notification-service-lib';
import { BullhornCompanyFiltersService } from './bullhorn.company-filters.service';
import { BullhornEntityFiltersComponent } from '../bullhorn.entity-filters.component';

@Component({
  selector: 'app-bullhorn-company-filters',
  templateUrl: '../bullhorn.entity-filters.component.html',
  styleUrls: ['../bullhorn.entity-filters.component.scss'],
  standalone: false,
})
export class BullhornCompanyFiltersComponent extends BullhornEntityFiltersComponent {
  constructor(protected service: BullhornCompanyFiltersService, protected messageNotificationService: MessageNotificationService) {
    super(service, messageNotificationService);
  }
}
